import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

export const GalleryDropDown = (
    { demoImages,
        close }
) => {
    const router = useRouter();
    return (
        <div className='gallery-navigation-content-wrapper'>
            <div className='gallery-navigation-right'>
                <div className='gallery-navigation-images-wrapper'>
                    {demoImages
                        .slice(0, 4)
                        .map((image, index) => {
                            return (
                                <Image
                                    key={index}
                                    src={image.fileLink}
                                    width={500}
                                    height={500}
                                    title={image.title}
                                    alt={image.altText}
                                    onClick={() => {
                                        router.push("/gallery");
                                        close();
                                    }}
                                />
                            );
                        })}
                </div>
            </div>
            <div className='gallery-navigation-left'>
                <div className='navigation-gallery-title-section'>
                    <h2>
                        FactoryCat - <span>Gallery</span>
                    </h2>
                    <p>
                        View our gallery to see our floor scrubbers and
                        sweepers in action. You can also view our
                        machines in different environments and settings.
                    </p>
                </div>
                <Link
                    href='/gallery'
                    onClick={close}
                    className='navigation-gallery-link'>
                    View Gallery
                </Link>
            </div>
        </div>
    );
}